import {useRef,useState} from 'react'
import { Box,FormControl, Heading, Text,Input,Checkbox, Flex,
  Button} from '@chakra-ui/react'
import { Link,useNavigate } from 'react-router-dom'
import styled from '@emotion/styled';
import { MdArrowBack as ArrowIcon} from "react-icons/md";
import {Form,Formik,Field} from "formik";
import { forgotPasswordSchema } from './LoginScheme';
import apiCall from '../../utils/apiCall';
import apiCallFormData from '../../utils/apiFormDataCall';
import { openAtom,modalAtom } from '../../context';
import { useAtom } from 'jotai';
import { useMutation } from 'react-query';

const emailSent = '/public-assets/email_sent.png';
const BoxStyle={
  display:'flex',
  flexDirection:'column',
  alignItems:'center',
  margin:'0'
}
const HeadStyle={
  fontSize:'24px',
  color:'var(--white-color)',
}

type Payload ={
  Email: string;
}

type LoginData = {
  Token: string;
  UserName: string;
  Id: string;
  expiryDate: string;
  Role: string;
  AdminUserHasChangePassword?:boolean;
  FirstName:string;

}

type JwtData = {
  nameid: string;
  email: string;
  role: string;
  RoleId: string;
}

export const ForgotPassword = () => {
  const [,setOpen] = useAtom(openAtom);
  const [,setModal] = useAtom(modalAtom);
  const navigate = useNavigate();
  const forgotPassword = async (data: FormData) => {
    return (await (apiCallFormData().post('/Authentication/ForgotPasswordAsync', data)))?.data as LoginData;
  };

  const loginMutation = useMutation(['post-user'], forgotPassword, {retry: 0});

  const initialValues = {
    email:'',
    password:''
  }
  return (
    <Box sx={BoxStyle}>
      <Heading sx={HeadStyle}>Forgot Password?</Heading>
      <Text color="var(--white-color)" margin="8px 0">
        Input your email address & we'll send you reset instructions
      </Text>
      <Formik
        initialValues={initialValues}
        validationSchema={forgotPasswordSchema}
        onSubmit={async (values)=>{
         
           //console.log(values);
            const data: FormData = new FormData();
            data.append('Email',values.email);
            data.append('IsAdmin',true.toString());
        
              await loginMutation.mutateAsync(data, {
                onSuccess: (data:any) => {
                  //console.log(data,'data');
                  if(data?.StatusCode == 200){
                    // alert(data.Message || `Reset sent to your email`)
                    setModal({
                      header:'',
                      content:<img style={{cursor:'pointer'}} onClick={()=>setOpen(false)} src={emailSent} alt="mail"/>,
                      hasHead:false
                    });
                    setOpen(true);
                  }

                },
                onError(error, variables, context) {
        
                },
                onSettled(data, error, variables, context) {
          
                },
        
              });
          
          

        }}
      >
        {(formik)=>{
          const {errors} = formik;
          return (
            <Form style={{width:'450px',padding:'20px',marginTop:'10px'}}>
              <FormControl 
              bg="var(--white-background)" 
              w="100%"
              p="5px 10px"  
              borderRadius="5px">
                <Input as={Field} type="text" name="email" placeholder='Username' />
              </FormControl>
                      
              <Button
                type="submit"
                color="var(--dark-green-color)"
                backgroundColor="var(--cipm-light-green)"
                width="100%"
                mt="15px"
                variant="solid"
              >{loginMutation.isLoading?'Loading':'Submit'}</Button>
             <Button display="block" mx="auto" textAlign="center" fontSize="1.2rem" colorScheme='none' mt="20px"  leftIcon={<ArrowIcon />} 
             bg="transparent" color="white"
             as={Link} to="/">
              Back To Login
             </Button>
          </Form>
          )
        }}
        
      </Formik>
      
      
      
        
       
     
    </Box>
  )
}
